import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DataTableBoardButton from './DataTableBoardButton'
    import {PanelTopClose, PanelTopOpen} from 'lucide-react'
import './Board.css'
import DataTableFilter from './DataTableFilter'
import ColumnSelector from './ColumnSelector'
import DownloadDataTable from './DownloadDataTable'
import {translate} from "react-i18next";
import ActionSelector from "./ActionSelector";

export class Board extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isSearchActive: false
        }
    }

    render() {
        return (
            <div
                className="DataTable-Board"
            >
                <div className="DataTable-Board-left">
                    {this.props.changeFiltersVisibility && (
                        <DataTableBoardButton onClick={this.props.changeFiltersVisibility}>
                            { this.props.filtersOpened ? <PanelTopClose className="DataTable-Board-icon" color="#3f51b5e6" size={16} /> : <PanelTopOpen className="DataTable-Board-icon" color="#3f51b5e6" size={16} /> }
                        </DataTableBoardButton>
                    )}
                    {
                        !this.props.noLeftBoard &&
                        <ColumnSelector
                            options={this.props.selectorOptions}
                            opened={this.props.columnSelectorOpened}
                            open={this.props.openColumnSelector}
                            changeColumnSelection={
                                this.props.changeColumnSelection
                            }
                            t={this.props.t}
                        />
                    }
                    {
                        !this.props.noLeftBoard &&
                        <DownloadDataTable
                            objects={this.props.objects}
                            columns={this.props.columns.filter(
                                column => !column.disableExport
                            )}
                            exportTableObject={this.props.exportTableObject}
                            protectedExport={this.props.protectedExport}
                            user={this.props.user}
                            filename={this.props.moduleName}
                            language={this.props.language}
                            t={this.props.t}
                        />
                    }
                    {
                        !!this.props.actions.length &&
                        <ActionSelector
                            actions={this.props.actions}
                            opened={this.props.actionSelectorOpened}
                            open={this.props.openActionSelector}
                            onClick={this.props.onActionClick}
                            moduleId={this.props.moduleId}
                        />
                    }
                </div>
                <div className="DataTable-Board-right">
                    {
                        (() => {
                            const totalCount = this.props.objects?.length
                            const count = this.state.isSearchActive
                                ? this.props.matchedCount
                                : this.props.objects?.length
                            return (
                                <span className="DataTable-Board-count">
                                    {!this.state.isSearchActive && this.props.displayedRowCount !== totalCount ? `${this.props.displayedRowCount} / ` : null} {count} {this.state.isSearchActive ?
                                    this.props.t("occurrence(s)", { disableCapitalize: true })
                                    : this.props.t("row(s)", { disableCapitalize: true })}
                                </span>
                            )
                    })()}
                    <DataTableFilter
                        value={this.props.filter}
                        onChange={this.props.changeFilter}
                        onFocus={() => this.setState({isSearchActive: true})}
                        onBlur={() => {
                            if (!this.state.filter) {
                                this.setState({isSearchActive: false})
                            }
                        }}
                        placeholder={this.props.searchPlaceholder}
                    />
                </div>
            </div>
        )
    }
}

Board.propTypes = {
    actions: PropTypes.array,
    actionSelectorOpened: PropTypes.bool.isRequired,
    openActionSelector: PropTypes.func.isRequired,
    selectorOptions: PropTypes.array.isRequired,
    columnSelectorOpened: PropTypes.bool.isRequired,
    openColumnSelector: PropTypes.func.isRequired,
    changeColumnSelection: PropTypes.func.isRequired,
    objects: PropTypes.array.isRequired,
    matchedCount: PropTypes.number,
    columns: PropTypes.array.isRequired,
    filter: PropTypes.string.isRequired,
    changeFilter: PropTypes.func.isRequired,
    changeFiltersVisibility: PropTypes.func,
    searchTooltip: PropTypes.string,
    searchPlaceholder: PropTypes.string,
    moduleName: PropTypes.string,
    moduleId: PropTypes.string
}

export default translate('platform')(Board)
